import nubian1 from "../images/water_nubian1.jpg";
import nubian2 from "../images/water_nubian2.jpg";
import nubian3 from "../images/water_nubian3.jpg";
import nubian4 from "../images/water_nubian4.jpg";
import nubian5 from "../images/water_nubian5.jpg";
import nubian6 from "../images/water_nubian6.jpg";
import nubian7 from "../images/water_nubian7.jpg";
import nubian8 from "../images/water_nubian8.jpg";
import nubian9 from "../images/water_nubian9.jpg";

import glacier1 from "../images/water_glacier1.jpg";
import glacier2 from "../images/water_glacier2.jpg";
import glacier3 from "../images/water_glacier3.jpg";
import glacier4 from "../images/water_glacier4.jpg";
import glacier5 from "../images/water_glacier5.jpg";
import glacier6 from "../images/water_glacier6.jpg";
import glacier7 from "../images/water_glacier7.jpg";
import glacier8 from "../images/water_glacier8.jpg";
import glacier9 from "../images/water_glacier9.jpg";
import glacier10 from "../images/water_glacier10.jpg";
import glacier11 from "../images/water_glacier11.jpg";
import glacier12 from "../images/water_glacier12.jpg";
import glacier13 from "../images/water_glacier13.jpg";
import glacier14 from "../images/water_glacier14.jpg";
import glacier15 from "../images/water_glacier15.jpg";
import glacier16 from "../images/water_glacier16.jpg";
import glacier17 from "../images/water_glacier17.jpg";
import glacier18 from "../images/water_glacier18.jpg";
import glacier19 from "../images/water_glacier19.jpg";
import glacier20 from "../images/water_glacier20.jpg";
import glacier21 from "../images/water_glacier21.jpg";
import glacier22 from "../images/water_glacier22.jpg";
import glacier23 from "../images/water_glacier23.jpg";
import glacier24 from "../images/water_glacier24.jpg";
import glacier25 from "../images/water_glacier25.jpg";

import optimos1 from "../images/water_optimos1.jpg";
import optimos2 from "../images/water_optimos2.jpg";
import optimos3 from "../images/water_optimos3.jpg";
import optimos4 from "../images/water_optimos4.jpg";

import steamline from "../images/water_steamline.jpg";

const water = {

  steamline: {
    client: 'Steamline Water Solutions',
    title: 'Greywater Filtration Unit',
    image_array: [
      {
        image: steamline,
        category: 'water',
        title: 'Greywater Filtration Unit',
        comment: 'Greywater Filtration Unit by Steamline Water Solutions'
      },
    ]
  },

  nubian: {
    client: 'Nubian',
    title: 'Greywater Treatment System',
    image_array: [
      {
        image: nubian1,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian1,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian2,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian3,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian4,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian5,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian6,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian7,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian8,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
      {
        image: nubian9,
        category: 'water',
        title: 'Greywater Treatment System',
        comment: 'Greywater Treatment System by Nubian'
      },
    ]
  },

  optimos: {
    client: 'Optimos',
    title: 'Quality Eye Frame',
    image_array: [
      {
        image: optimos1,
        category: 'water',
        title: 'Quality Eye Frame',
        comment: 'Quality Eye Frame by Optimos'
      },
      {
        image: optimos2,
        category: 'water',
        title: 'Quality Eye Frame',
        comment: 'Quality Eye Frame by Optimos'
      },
      {
        image: optimos3,
        category: 'water',
        title: 'Quality Eye Frame',
        comment: 'Quality Eye Frame by Optimos'
      },
      {
        image: optimos4,
        category: 'water',
        title: 'Quality Eye Frame',
        comment: 'Quality Eye Frame by Optimos'
      },
    ]
  },

  glacier: {
    client: 'Glacier Filtration',
    title: 'Filtration Vessels',
    image_array: [
      {
        image: glacier1,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier2,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier3,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier4,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier5,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier6,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier7,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier8,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier9,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier10,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier11,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier12,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier13,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier14,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier15,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier16,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier17,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier18,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier19,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier20,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier21,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier22,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier23,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier24,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
      {
        image: glacier25,
        category: 'water',
        title: 'Filtration Vessels',
        comment: 'Filtration Vessels by Glacier Filtration'
      },
    ]
  },

};

export default water;